<template>
  <f7-page>
    <div v-if="!loaded" class="preloader-overlay">
      <div class="preloader-card">
        <f7-preloader></f7-preloader>
        <div class="preloader-text">
          {{ $t('loading') }}
        </div>
      </div>
    </div>
    <div class="complaint-form-container">
      <div class="margin-bottom complaintRegister">
        <div class="card no-margin">
          <div class="complaint-form-title display-flex align-center">
            <img
              :src="getIconPath('nueva_incidencia.svg')"
              alt="Icono Nueva Incidencia"
              class="complaint-form-icon"
            />
            <span>{{ $t('complaintRegister') }}</span>
          </div>

            <div class="complaint-register-layout">
              <div class="complaint-register-content">

              <div class="complaint-register-chat">
                <CopilotAgentChat
                  :correo-contacto="correoContacto"
                  :codigo-cliente="codigoCliente"
                  :codigo-direccion="codigoDireccion"
                />
              </div>

              </div>
            </div>
          </div>
        </div>
      </div>
  </f7-page>
</template>

<script>
import CopilotAgentChat from './CopilotAgentChat.vue';
import { mapActions, mapState } from 'vuex';

export default {
  components: {
    CopilotAgentChat,
  },
  data() {
    return {
      isPopupVisible: false,
      isErrorPopupVisible: false,
      customStore: null,
      params: {
        receptionDate_after: '',
        receptionDate_before: '',
        endDate_after: '',
        endDate_before: '',
        atc_name: '',
        status: '5',
        sample_type: '',
        analyse_type: '',
      },
      loaded: false,
    };
  },
  computed: {
    correoContacto() {
      return this.$store.state.user?.authenticatedUser?.email || '';
    },
    codigoDireccion(){
      return this.$store.state.contact?.address || ''
    },

    codigoCliente() {
      return this.$store.state.contact?.company || '';
    },

    ...mapState('complaintManagement', [
      'origins',
      'newComplaintCode',
    ]),
  },
  async mounted() {
    try {
      await this.fetchOrigins();

      // Aquí aplicamos la traducción según el idioma actual
      // const translated = this.origins.map((item) => {
      //   return {
      //     ...item,
      //     translatedTitle: this.$t(`TranslatedComplaintsOrigins.${item.titleKey}`),
      //   };
      // });

      // const fakeExtraOrigin = {
      //   title: 'Nuevo Origen Backend',
      //   titleKey: null,
      //   etag: null
      // };

      // const fakeOrigins = [...this.origins, fakeExtraOrigin];

      // he simuldao un title nuevo que no lo tengo mapeado cambiado por esto fakeOrigins this.origins

      const translated = this.origins.map((item) => {
        const translatedTitle = item.titleKey
          ? this.$t(`TranslatedComplaintsOrigins.${item.titleKey}`)
          : item.title;

        return {
          ...item,
          translatedTitle,
        };
      });

      this.customStore = translated;
    } catch (error) {
      this.$notifyDX(
        {
          message: this.$t('reEnterCredentials'),
          width: 350,
        },
        'info',
        3000
      );
    } finally {
      this.loaded = true;
    }
  },
  beforeMount() {
    this.setCurrentRoute([
      {
        name: this.$t('complaintRegister'),
        disabled: false,
        page: 'ComplaintRegister',
        active: true,
      },
    ]);
  },
  methods: {
    showPopup() {
      this.isPopupVisible = true;
    },
    handleConfirm() {
      this.isPopupVisible = false; // Cierra el popup
      // Puedes agregar aquí la lógica de redirección, como:
      this.goToBack();
    },
    showErrorPopup() {
      this.isErrorPopupVisible = true;
    },
    handleErrorPopupClose() {
      // <-- Nuevo método para manejar el cierre del pop-up de error
      this.isErrorPopupVisible = false;
      // Aquí podrías decidir si redirigir o no.
      // En tu Figma, el botón "Volver a crear incidencia" lo maneja.
    },
    handleErrorGoBack() {
      // <-- Nuevo método para "Volver a crear incidencia"
      this.isErrorPopupVisible = false;
      // Lógica para volver a la página de creación de incidencias o cerrar el formulario
      // this.goToBack(); // Por ejemplo, vuelve atrás
    },
    handleErrorContactSupport() {
      this.isErrorPopupVisible = false; // Cierra el popup

      let mail = '';
      // Asumiendo que `this.chosenLanguage` está disponible en este componente
      if (this.chosenLanguage === 'es') {
        mail = 'atencioncliente.esp@agqlabs.com';
      } else if (this.chosenLanguage === 'en') {
        mail = 'info@agqlabs.com';
      } else if (this.chosenLanguage === 'it') {
        mail = 'italia@agqlabs.com';
      } else if (this.chosenLanguage === 'pt') {
        mail = 'infoportugal@agqlabs.com';
      }
      window.open(`mailto:${mail}`, '_blank');
    },
    getIconPath(fileName) {
      return `${
        this.environment === 'development' ? '../../' : './'
      }static/icons/${fileName}`;
    },
    goToBack() {
      this.$f7router.navigate(
        { name: this.$f7router.previousRoute.name },
        {
          animate: true,
          transition: 'f7-fade',
        }
      );
    },
    async submitComplaint() {
      try {
        // Mostramos el preloader
        this.loaded = false;
        // Se valida el formulario de incidencia con los campos obligatorios
        const validationResult =
          this.$refs.complaintForm.validateForm();

        if (!validationResult.isValid) {
          this.$notifyDX(
            {
              message: this.$t('fillRequiredFields'),
              width: 500,
            },
            'error'
          );
          this.loaded = true;
          return;
        }

        const formData = this.$refs.complaintForm.getFormData();
        // Si el campo 'Parametro' tiene contenido, se transforma en un array con un único string
        // y se convierte a formato JSON válido para su envío al backend
        if (
          formData.Parametro &&
          typeof formData.Parametro === 'string'
        ) {
          const cleaned = formData.Parametro.trim();
          formData.Parametro = JSON.stringify([cleaned]);
        }
        // Se envían el asunto y cuerpo del email de confirmación según el idioma del cliente
        formData.emailHeader = this.$t(
          'complaintConfirmationEmail.emailHeader'
        );
        formData.emailBody = this.$t(
          'complaintConfirmationEmail.emailBody'
        );

        // Se registra la incidencia, almacenando el nuevo código en el módulo de incidencias
        await this.registerComplaint(formData);
        // Si hay archivos adjuntos, se comprimen en un ZIP y se llama al servicio para adjuntarlos
        const files =
          this.$refs.complaintFileUploader.getUploadedFiles();

        if (files && files.length > 0) {
          // Crear el ZIP
          const zipBlob = await this.createZipFromFiles(files);

          // Crear el JSON para enviar al módulo de incidencias
          const zipData = {
            TituloReclamacion: this.newComplaintCode,
            ArchivoZip: zipBlob,
          };

          await this.attachComplaintFiles(zipData);
        }

        // Ocultamos el preloader
        this.loaded = true;
        // Se notifica si ha ido ok y se vuelve a la página anterior
        // this.$notifyDX(
        //   {
        //     message: this.$t('ComplaintRegistered'),
        //     width: 450,
        //   },
        //   'success',
        //   2000
        // );
        // this.goToBack();
        this.showPopup();
      } catch (error) {
        // Notificación de error en caso de fallo en el registro o adjunto
        // this.$notifyDX(
        //   {
        //     message: this.$t('internalServerError'),
        //     width: 550,
        //   },
        //   'error',
        //   NOTIFY_TIME_LONG
        // );
        // Ocultamos el preloader
        this.$f7.preloader.hide();
        this.showErrorPopup();
      }
    },
    async createZipFromFiles(files) {
      const zip = new JSZip();

      // Leer todos los contenidos en paralelo
      const fileContents = await Promise.all(
        files.map((file) => file.arrayBuffer())
      );

      // Añadirlos al ZIP
      files.forEach((file, index) => {
        zip.file(file.name, fileContents[index]);
      });

      return zip.generateAsync({ type: 'blob' });
    },
    ...mapActions('homeSamples', ['getStore', 'getStoreWithFilters']),
    ...mapActions('breadcrumb', ['setCurrentRoute']),
    ...mapActions('complaintManagement', [
      'fetchOrigins',
      'registerComplaint',
      'attachComplaintFiles',
    ]),
  },
};
</script>

<style scoped lang="sass" src="./complaint-register.scss"></style>
